import "./header";
import "./algemene";
// import "./filter-popup";
import "./thankyou";
import "./checkout";
import "./cart-counter";
import "./move-cart-responsive";
import "./product-gallery-slider";
import "./product-category-header";
